LoadingBox = createReactClass
  displayName: 'LoadingBox'

  render: ->
    <div className='box-loading' />

module.exports = LoadingBox
